// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../.pnpm/css-loader@5.2.7_webpack@5.104.1/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../.pnpm/css-loader@5.2.7_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@layer reset, libraries, power-select-dropdowns, utils, components", "",{"version":3,"sources":["webpack://./assets/layers.scss"],"names":[],"mappings":"AAAA","sourcesContent":["@layer reset, libraries, power-select-dropdowns, utils, components;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
